import React from 'react';
import { Form, Col } from 'react-bootstrap';
import { FieldArray, getIn } from 'formik';
import PropTypes from 'prop-types';
import FormGroup from '../FormGroup';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import cloneDeep from 'lodash/cloneDeep';
import './FormCombo.scss';
import { Tooltip } from '~/components/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

function FormCombo({ sm, name, headerClass, wrapperClass, title, options, renderFunc, valueObj, tooltip }) {
    return (
        <FieldArray
            name={name}
            render={(arrayHelpers) => {
                const { form } = arrayHelpers;
                const arrayVals = cloneDeep(getIn(form.values, name)) ?? []; //getIn() is to extract a value from an object by a path: https://stackoverflow.com/a/56102789/11297747

                arrayVals.forEach((item) => {
                    item.nodeRef = React.createRef(null);
                });

                return (
                    <>
                        <TransitionGroup className={`transition-group row ${wrapperClass}`}>
                            {arrayVals.map(({ defaultValue1, defaultValue2, nodeRef }, index) => {
                                const increment = () => {
                                    if (arrayVals.length >= options.length) return;

                                    arrayHelpers.push(valueObj);
                                };

                                const decrement = () => {
                                    if (arrayVals.length === 1) return;

                                    arrayHelpers.remove(index);
                                };

                                return (
                                    <CSSTransition
                                        nodeRef={nodeRef}
                                        timeout={300}
                                        key={index}
                                        classNames="item"
                                    >
                                        <Col
                                            ref={nodeRef}
                                            sm={sm}
                                        >
                                            <FormGroup>
                                                <FormGroup.Header
                                                    increment={increment}
                                                    className={`${headerClass}`}
                                                >
                                                    {tooltip ? (
                                                        <>
                                                            {title} {index + 1}
                                                            <Tooltip content={tooltip}>
                                                                <FontAwesomeIcon
                                                                    icon={faCircleInfo}
                                                                    size="xs"
                                                                    className="fa-light fa-fw ml-1"
                                                                />
                                                            </Tooltip>
                                                        </>
                                                    ) : (
                                                        <>
                                                            {title} {index + 1}
                                                        </>
                                                    )}
                                                </FormGroup.Header>
                                                <FormGroup.Body>
                                                    <Form.Row>
                                                        {renderFunc(index, defaultValue1, defaultValue2)}
                                                    </Form.Row>
                                                </FormGroup.Body>
                                                <FormGroup.Footer decrement={decrement}></FormGroup.Footer>
                                            </FormGroup>
                                        </Col>
                                    </CSSTransition>
                                );
                            })}
                        </TransitionGroup>
                    </>
                );
            }}
        />
    );
}
FormCombo.defaultProps = {
    headerClass: '',
    wrapperClass: '',
    tooltip: '',
};

FormCombo.propTypes = {
    sm: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    headerClass: PropTypes.string,
    options: PropTypes.array.isRequired,
    renderFunc: PropTypes.func.isRequired,
    valueObj: PropTypes.object.isRequired,
    wrapperClass: PropTypes.string,
    tooltip: PropTypes.string,
};
export default FormCombo;
